const DOTS = "...";

const SKIN_TONES = {
  UNKNOWN: 0,
  DARK: 1,
  MEDIUM_DARK: 2,
  MEDIUM: 3,
  MEDIUM_LIGHT: 4,
  LIGHT: 5,
};

const PLAYER_IMAGE_POSES = {
  PROFILE_R: "001-profile-R",
  BACK: "002-back",
  PROFILE_SAD_R: "006-profile-sad-R",
  BACK_SAD: "007-back-sad",
  STANCE_R: "011-stance-R",
  KICK_R: "013-kick-R",
  TEAM_BACK: "014-team-back",
  SIT_R: "015-sit-R",
  PASS_R: "023-pass-R",
  RUN_R: "024-run-R",
  TEAM_L_SAD: "026-team-L-sad",
  PROFILE_L: "051-profile-L",
  BACK_L: "055-back-L",
  PROFILE_SAD_L: "056-profile-sad-L",
  STANCE_L: "061-stance-L",
  TEAM_SIT_L: "064-team-sit-L",
  SIT_L: "065-sit-L",
  ANIM_RUN_R: "101-run-R",
  ANIM_QB_PRESNAP_R: "106-QB-presnap-R",
  ANIM_QB_PASS_R: "107-QB-pass-R",
  ANIM_KICK_R: "108-kick-R",
  ANIM_CATCH_R: "109-catch-R",
  ANIM_CHEER_R: "117-cheer-R",
  ANIM_TEAM_CHEER_L: "125-team-cheer-L",
  ANIM_RUN_L: "151-run-L",
  ANIM_CHEER_L: "167-cheer-L",
};

export { DOTS, SKIN_TONES, PLAYER_IMAGE_POSES };
